import React from 'react';
import styled from 'styled-components';
import icons from './Icons';

const Container = styled.div<{
  color?: string;
}>`
  /* width: fit-content;
  display: table; */
  height: fit-content;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  svg {
    path,
    polygon,
    ellipse {
      fill: ${({ color }) => color || 'var(--textColor)'};
    }
  }
`;

const iconSizeMap = { 12: ' 12px', 18: '18px', 20: '20px' };

interface Props {
  name: keyof typeof icons;
  color?: string;
  style?: React.CSSProperties;
  className?: string;
}

function Icon({ name, color, style, className }: Props) {
  return (
    <Container color={color} style={style} className={className}>
      {icons[name]}
    </Container>
  );
}

export default Icon;
